<template>
  <div>
    <div v-if="loading">
      <LiveLogoLoading />
    </div>
    <div v-else>
      <Navbar />
      <div class="slider">
        <div class="item">
          <div
            class="slider-bg"
            v-bind:style="{
              'background-image':
                'url(' + require('../assets/image/blog.jpg') + ')'
            }"
          ></div>
          <h1>آخرین اخبار و مطالب وبلاگ</h1>
        </div>
      </div>
      <div class="blog-posts">
        <div class="container">
          <div class="row">
            <div class="col-6 col-md-4 mt-4" v-for="blogPost in blogPosts">
              <div class="icon-box">
                <div
                  class="img"
                  v-bind:style="{
                    'background-image':
                      'url(' + rootImagePath + blogPost.imagePath + ')'
                  }"
                ></div>
                <strong>{{ blogPost.name }}</strong>
                <p v-html="blogPost.caption"></p>
                <div class="col-12 text-left">
                  <router-link
                    :to="{
                      name: 'content',
                      params: { slug: blogPost.slug.replace(' ', '-') }
                    }"
                    >مشاهده بیشتر</router-link
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  </div>
</template>
<script>
import LiveLogoLoading from "@/components/LiveLogoLoading";
import Navbar from "./share/Navbar";
import Footer from "./share/Footer";

export default {
  components: {
    LiveLogoLoading,
    Navbar,
    Footer
  },

  data() {
    return {
      loading: true,
      rootImagePath: null,
      blogPosts: []
    };
  },

  beforeMount() {
    this.initBlogPosts();
  },

  methods: {
    initBlogPosts() {
      axios({ method: "get", url: "/api/General/GetContentBlogPosts" })
        .then(response => {
          this.rootImagePath = response.data.rootImagePath;
          this.blogPosts = response.data.blogPosts;
          this.loading = false;
        })
        .catch(error => {});
    }
  }
};
</script>
<style scoped>
.slider,
.slider .item,
.slider .slider-bg {
  width: 100%;
  float: left;
  height: 400px;
}

.slider {
  padding: 0 !important;
}

.slider .item,
.slider .slider-bg {
  overflow: hidden;
}

.slider .slider-bg {
  background-position: top center;
  background-size: cover;
  animation-duration: 8s;
  animation-timing-function: linear;
}

.slider .slider-bg::after {
  content: "";
  width: 100%;
  height: 400px;
  position: absolute;
  top: 0;
  left: 0;
  background: #292929;
  opacity: 0.7;
}

.slider h1 {
  position: relative;
  top: -100px;
  text-align: center;
  color: #ddd;
}

.blog-posts {
  width: 100%;
  float: right;
  padding: 100px 0;
}

.blog-posts .icon-box {
  padding: 20px;
  border-radius: 6px;
  background: #f8f8f8;
  transition: ease-in-out 0.3s;
}

.blog-posts .icon-box .img {
  width: 100%;
  height: 200px;
  background-position: center center;
  background-size: cover;
  transition: all 0.6s;
  position: relative;
  float: right;
  z-index: 10;
  margin-bottom: 20px;
}

.blog-posts .icon-box .img::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: #292929;
  transition: all 0.5s;
  opacity: 0;
}

.blog-posts .icon-box i {
  float: left;
  color: #3498db;
  font-size: 40px;
}

.blog-posts .icon-box h4 {
  margin-left: 70px;
  font-weight: 700;
  margin-bottom: 15px;
  font-size: 18px;
}

.blog-posts .icon-box h4 a {
  color: #384046;
  transition: 0.3s;
}

.blog-posts .icon-box p {
  margin-left: 70px;
  line-height: 24px;
  font-size: 14px;
}

.blog-posts .icon-box:hover {
  box-shadow: 0px 2px 22px rgba(0, 0, 0, 0.08);
}

.blog-posts .icon-box:hover h4 a {
  color: #3498db;
}
</style>
